import React, { useState, useRef, useEffect } from 'react'
import Cookies from 'js-cookie'
import api from '../../services/api'
import { Dropdown, Button, Modal, OverlayTrigger, Tooltip } from 'react-bootstrap'
import { toast } from 'react-toastify'
import AnimationWarningLottie from '../AnimationWarningDeleteConfim/AnimationWarningLottie'
import user3 from '../../assets/images/user/03.jpg'
import { formatDistanceToNow, parseISO } from 'date-fns'
import { ptBR } from 'date-fns/locale'
import like_btn from '../../assets/images/icon/like_btn.png'
import love_btn from '../../assets/images/icon/love_btn.png'
import haha_btn from '../../assets/images/icon/haha_btn.png'
import wow_btn from '../../assets/images/icon/wow_btn.png'
import angry_btn from '../../assets/images/icon/angry_btn.png'
import sad_btn from '../../assets/images/icon/sad_btn.png'
import EmojiPicker from 'emoji-picker-react'
import { useDispatch } from 'react-redux'
import { set_handle_comments } from '../../store/setting/actions'
import ShowReactionCommentsModal from '../../components/Reactions/modalShowReactionsComments';
import DOMPurify from 'dompurify'
import Quill from 'quill';import ImageResize from 'quill-image-resize';
import 'quill/dist/quill.snow.css';
import 'quill-mention/dist/quill.mention.css';
import { Mention, MentionBlot } from "quill-mention";

Quill.register({ "blots/mention": MentionBlot, "modules/mention": Mention });
Quill.register('modules/imageResize', ImageResize);

const Index = ({ comment }) => {
  const editorRef = useRef(null);
  const quillInstance = useRef(null);
  const sanitizedText = DOMPurify.sanitize(parsePostText(comment.text));
  const dispatch = useDispatch()
  const [modalCommentShow, setModalCommentShow] = useState(false)
  const logged_user = Cookies.get('userId')
  const [isEditingComment, setIsEditingComment] = useState(null)
  const [editedCommentText, setEditedCommentText] = useState(comment.text)
  const [newReaction, setNewReaction] = useState(comment.user_reaction)
  const [newReactionsCounter, setNewReactionsCounter] = useState(comment.reaction_counter)
  const [reactionsModalShow, setReactionsModalShow] = useState(false)
  const [showPicker, setShowPicker] = useState(false)

  const handleEmojiSelect = (emojiObject, event) => {
    const quill = quillInstance.current;

    if (!quill) {
      console.error('Erro: Instância do Quill não disponível para inserir emoji.');
      return;
    }

    const emojiToInsert = String(emojiObject.emoji || '');

    if (emojiToInsert === '') {
      console.warn('Atenção: Emoji selecionado está vazio ou inválido. Não será inserido.');
      return;
    }

    try {
      let currentText = quill.getText();
      
      const editorLength = quill.getLength();
      let insertionIndex = editorLength;

      if (currentText.endsWith('\n')) {
        insertionIndex = editorLength - 1;

        if (insertionIndex < 0) {
            insertionIndex = 0;
        }
      }
      
      quill.insertText(insertionIndex, emojiToInsert);
      
      quill.setSelection(insertionIndex + emojiToInsert.length);

      setShowPicker(false);
    } catch (error) {
      console.error("Erro ao inserir emoji no Quill:", error);
      console.error("Detalhes do erro:", error.message, error.stack);
    }
  };

  const commentDelete = async (comment_id) => {
    await api.post(`/api/comments/delete/${comment_id}`).then(() => {
      setModalCommentShow(false)
      dispatch(set_handle_comments(comment.post_id))
      toast.success('Comentario deletado com sucesso.', { autoClose: 1000 })
    }).catch(err => toast.error('Erro ao deletar comentario', { autoClose: 3000 }))
  }

  const startEditingComment = (comment) => {
    setIsEditingComment(comment.id)
  }

  function parsePostText(texto) {
    if (texto) {
      return texto.replace(/\{@}\[([^\]]+)\]\((\d+)\)/g, '<a href="/users/profile/$2">@$1</a>');
    } else {
      return texto;
    }
  }

  const updateComment = async (comment_id) => {
    await api.post(`/api/comments/update/${comment_id}`, {
      newComment: editedCommentText,
      logged_user,
    }).then(() => {
      toast.success('Comentário editado com sucesso.', { autoClose: 1000 })
      setIsEditingComment(null)
    }).catch(err => toast.error('Erro ao editar comentário', { autoClose: 3000 }))
  }

  function DeleteCommentConfirmationModal(props) {
    return (
      <Modal
        {...props}
        aria-labelledby='contained-modal-title-vcenter'
        centered
      >
        <Modal.Header id='modalHeader' closeButton>
          <div id='divModalTitle'>
            <Modal.Title id='modalTitle'>
              Exclusão de comentário
            </Modal.Title>
          </div>
        </Modal.Header>
        <Modal.Body id='modalBody'>
          <div className='d-flex justify-content-center'>
            <AnimationWarningLottie />
          </div>
          <div className='d-flex justify-content-center'>
            <p>
              Você tem certeza de que deseja remover esse comentário ?
            </p>
          </div>
        </Modal.Body>
        <Modal.Footer id='modalFooter'>
          <Button id='yesButton' onClick={() => commentDelete(props.show)}>Sim</Button>
          <Button id='noButton' onClick={props.onHide}>Não</Button>
        </Modal.Footer>
      </Modal>
    )
  }

  const sendReaction = async (reaction) => {
    await api.post(`/api/reactionComment/store`, {
      comment_id: comment.id,
      reaction
    }).catch(err => toast.error('Erro ao reagir post', { autoClose: 3000 }))
  }

  const removeReaction = async () => {
    setNewReactionsCounter(prev => prev - 1)
    setNewReaction('')
    await api.delete(`/api/reactionComment/destroy/${comment.id}`).catch(err => toast.error('Erro ao deletar reação', { autoClose: 3000 }))
  }

  const handleReaction = (reaction) => {
    if (!newReaction) {
      setNewReactionsCounter(prev => prev + 1)
    }

    setNewReaction(reaction)
    sendReaction(reaction)
  }

  const openModalReaction = () => {
    setReactionsModalShow(true);
  };

  function convertMentionsToCustomFormat(html) {
    const div = document.createElement('div');
    div.innerHTML = html;

    const mentions = div.querySelectorAll('span.mention');

    mentions.forEach(span => {
      const name = span.dataset.value;
      const id = span.dataset.id;

      const formatted = `{@}[${name}](${id})`;

      const textNode = document.createTextNode(formatted);
      span.parentNode.replaceChild(textNode, span);
    });

    return div.innerHTML;
  }

  function convertCustomFormatToMentions(text) {
    const mentionRegex = /\{@\}\[([^\]]+)\]\((\d+)\)/g;

    const html = text.replace(mentionRegex, (match, name, id) => {
      return `<span class="mention" data-denotation-char="@" data-id="${id}" data-value="${name}"><span contenteditable="false"><span class="ql-mention-denotation-char">@</span><span class="ql-mention-value">${name}</span></span></span>`;
    });

    return html;
  }

  useEffect(() => {
    if (isEditingComment && editorRef.current) {
      if (!quillInstance.current) {
        const quill = new Quill(editorRef.current, {
          theme: "snow",
          placeholder: 'Escreva algo e compartilhe com seus amigos...',
          modules: {
            mention: {
              allowedChars: /^[A-Za-z\sÅÄÖåäö]*$/,
              mentionDenotationChars: ["@"],
              source: async function (searchTerm, renderList) {
                try {
                  const response = await api.get(`/api/get_suggestions_web`);
                  const { suggestions } = response.data;
                  const values = suggestions;

                  if (searchTerm.length === 0) {
                    renderList(values, searchTerm);
                  } else {
                    const matches = values.filter(value =>
                      value.value.toLowerCase().includes(searchTerm.toLowerCase())
                    );
                    renderList(matches, searchTerm);
                  }
                } catch (error) {
                  console.error("Erro ao buscar sugestões:", error);
                  renderList([], searchTerm);
                }
              }
            },
            toolbar: [],
            clipboard: {
              matchVisual: false,
              matchers: [
                [
                  Node.TEXT_NODE,
                  (node, delta) => {
                    const text = node.data;
                    if (text.match(/(https?:\/\/.*\.(?:png|jpg|jpeg|gif|svg))/i)) {
                      return { ops: [] };
                    }
                    return delta;
                  },
                ],
              ],
            },
          },
        });

        quill.clipboard.dangerouslyPasteHTML(convertCustomFormatToMentions(comment.text));
        quill.on("text-change", (delta, oldDelta, source) => {
          if (source === 'user' || source === 'api') {
            const editorHTML = quill.root.innerHTML;
            const customFormatted = convertMentionsToCustomFormat(editorHTML);
            setEditedCommentText(customFormatted);
          }
        });

        quillInstance.current = quill;
      }
    }

    return () => {
      if (quillInstance.current) {
        const toolbar = quillInstance.current.getModule('toolbar');
        if (toolbar && toolbar.container) {
          toolbar.container.remove();
        }

        quillInstance.current = null;
      }

      if (editorRef.current) {
        editorRef.current.innerHTML = "";
      }
    };
  }, [isEditingComment]);

  return (
    <>
      <DeleteCommentConfirmationModal
        show={modalCommentShow}
        onHide={() => setModalCommentShow(false)}
      />

      <ShowReactionCommentsModal
        comment_id={comment.id}
        showModalReactionComments={reactionsModalShow}
        setShowModalReactionComments={setReactionsModalShow}
        onHide={() => setReactionsModalShow(false)}
      />

      <ul className='list-inline m-o p-0 comment-list'>
        <li className='mb-3'>
          <div className='comment-list-block'>
            <div className='d-flex align-items-center gap-3'>
              <div className='comment-list-user-img flex-shrink-0'>
                <img
                  src={comment.image_profile ?? user3}
                  alt='userimg'
                  className='avatar-48 rounded-circle img-fluid'
                  loading='lazy'
                />
              </div>
              <div className='comment-list-user-data'>
                <div className='d-inline-flex align-items-center gap-1 flex-wrap'>
                  <h6 className='m-0'>{comment.name}</h6>
                  <span className='d-inline-block text-primary'>
                    <svg
                      className='align-text-bottom'
                      xmlns='http://www.w3.org/2000/svg'
                      width='17'
                      height='17'
                      viewBox='0 0 17 17'
                      fill='none'
                    >
                      <path
                        fillRule='evenodd'
                        clipRule='evenodd'
                        d='M12.2483 0.216553H4.75081C2.13805 0.216553 0.5 2.0665 0.5 4.68444V11.7487C0.5 14.3666 2.13027 16.2166 4.75081 16.2166H12.2475C14.8689 16.2166 16.5 14.3666 16.5 11.7487V4.68444C16.5 2.0665 14.8689 0.216553 12.2483 0.216553Z'
                        fill='currentColor'
                      />
                      <path
                        d='M5.5 8.21627L7.50056 10.216L11.5 6.21655'
                        stroke='white'
                        strokeWidth='1.5'
                        strokeLinecap='round'
                        strokeLinejoin='round'
                      />
                    </svg>
                  </span>
                  <span className='fw-medium small text-capitalize'>
                    {formatDistanceToNow(parseISO(comment.created_at), { addSuffix: true, locale: ptBR })}
                  </span>

                  <div className='card-post-toolbar'>
                    {
                      comment.user_id == logged_user ? (
                        <Dropdown>
                          <Dropdown.Toggle id='post-option' as='span' >
                            <span className='material-symbols-outlined'>more_horiz</span>
                          </Dropdown.Toggle>
                          <Dropdown.Menu className='m-0 p-0'>
                            <Dropdown.Item className=' p-3' to='#' onClick={() => startEditingComment(comment)}>
                              <div className='d-flex align-items-top'>
                                <span className='material-symbols-outlined'>
                                  edit
                                </span>
                                <div className='data ms-2'>
                                  <h6>Editar</h6>
                                </div>
                              </div>
                            </Dropdown.Item>
                            <Dropdown.Item className=' p-3' to='#' onClick={() => setModalCommentShow(comment.id)}>
                              <div className='d-flex align-items-top'>
                                <span className='material-symbols-outlined'>
                                  delete
                                </span>
                                <div className='data ms-2'>
                                  <h6>Deletar</h6>
                                </div>
                              </div>
                            </Dropdown.Item>
                          </Dropdown.Menu>
                        </Dropdown>
                      ) : ''
                    }
                  </div>

                  <span
                    className='text-capitalize font-size-14 fw-medium'
                    type='button'
                    data-bs-toggle='modal'
                    data-bs-target='#likemodal'
                  >
                    {
                      newReactionsCounter > 0 ? (
                        <div>
                          <img src={like_btn} className='img-fluid me-2' alt='' style={{ 'height': '25px', 'width': '25px' }} onClick={openModalReaction} /> {newReactionsCounter}
                        </div>
                      ) : ''
                    }
                  </span>
                </div>
              </div>
            </div>
            <div className='comment-list-user-comment'>
              {isEditingComment === comment.id ? (
                <div>
                  <div className='form-control' ref={editorRef}></div>

                  <Button className='btn btn-primary mt-2' style={{ marginRight: '5px' }} onClick={() => setShowPicker(!showPicker)}>
                    <span className='material-symbols-outlined align-text-top font-size-20'>
                      add_reaction
                    </span>
                  </Button>

                  <Button className='btn btn-primary mt-2' style={{ marginRight: '5px' }} onClick={() => updateComment(comment.id)}>Salvar</Button>
                  <Button className='btn btn-danger mt-2' onClick={() => {
                    setIsEditingComment(null)
                    setEditedCommentText(sanitizedText)
                  }}>Cancelar</Button>

                  {showPicker && (
                    <div className='mt-3'>
                      <EmojiPicker className="w-50" onEmojiClick={handleEmojiSelect} />
                    </div>
                  )}
                </div>
              ) : (
                <div
                  className='comment-list-user-comment-text'
                  dangerouslySetInnerHTML={{
                    __html: DOMPurify.sanitize(parsePostText(editedCommentText))
                  }}
                />
              )}

              <div className='comment-list-action mt-2'>
                <ul className='list-inline m-0 p-0 d-flex align-items-center gap-2'>
                  <li>
                    <div className='like-block position-relative d-flex align-items-center flex-shrink-0'>
                      <div className='like-data'>
                        <div className='dropdown'>
                          <span
                            className='dropdown-toggle'
                            data-bs-toggle='dropdown'
                            aria-haspopup='true'
                            aria-expanded='false'
                            role='button'
                          >
                            {
                              !newReaction ? (
                                <span className='material-symbols-outlined align-text-top font-size-20'>
                                  thumb_up
                                </span>
                              ) : (
                                <img src={newReaction === 'like' ? like_btn : newReaction === 'love' ? love_btn : newReaction === 'haha' ? haha_btn : newReaction === 'wow' ? wow_btn : newReaction === 'sad' ? sad_btn : newReaction === 'angry' ? angry_btn : ''} className='img-fluid me-2' alt='' onClick={() => removeReaction()} style={{ 'height': '35px', 'width': '35px' }} />
                              )
                            }

                            {' '}
                            <span className='fw-medium'>{
                              newReaction === 'like' ? 'Gostei' : newReaction === 'love' ? 'Amei' : newReaction === 'haha' ? 'Haha' : newReaction === 'wow' ? 'Uau' : newReaction === 'sad' ? 'Triste' : newReaction === 'angry' ? 'Grr' : 'Reagir'
                            }</span>
                          </span>
                          <div className='dropdown-menu py-2 shadow'>
                            <OverlayTrigger
                              placement='top'
                              overlay={<Tooltip>Gostei</Tooltip>}
                              className='ms-2 me-2'
                            >
                              <img src={like_btn} className='img-fluid me-2' alt='' onClick={() => handleReaction('like')} style={{ 'height': '35px', 'width': '35px' }} />
                            </OverlayTrigger>
                            <OverlayTrigger
                              placement='top'
                              overlay={<Tooltip>Amei</Tooltip>}
                              className='me-2'
                            >
                              <img src={love_btn} className='img-fluid me-2' alt='' onClick={() => handleReaction('love')} style={{ 'height': '35px', 'width': '35px' }} />
                            </OverlayTrigger>
                            <OverlayTrigger
                              placement='top'
                              overlay={<Tooltip>HaHa</Tooltip>}
                              className='me-2'
                            >
                              <img src={haha_btn} className='img-fluid me-2' alt='' onClick={() => handleReaction('haha')} style={{ 'height': '35px', 'width': '35px' }} />
                            </OverlayTrigger>
                            <OverlayTrigger
                              placement='top'
                              overlay={<Tooltip>Uau</Tooltip>}
                              className='me-2'
                            >
                              <img src={wow_btn} className='img-fluid me-2' alt='' onClick={() => handleReaction('wow')} style={{ 'height': '35px', 'width': '35px' }} />
                            </OverlayTrigger>
                            <OverlayTrigger
                              placement='top'
                              overlay={<Tooltip>Triste</Tooltip>}
                              className='me-2'
                            >
                              <img src={sad_btn} className='img-fluid me-2' alt='' onClick={() => handleReaction('sad')} style={{ 'height': '35px', 'width': '35px' }} />
                            </OverlayTrigger>
                            <OverlayTrigger
                              placement='top'
                              overlay={<Tooltip>Grr</Tooltip>}
                              className='me-2'
                            >
                              <img src={angry_btn} className='img-fluid me-2' alt='' onClick={() => handleReaction('angry')} style={{ 'height': '35px', 'width': '35px' }} />
                            </OverlayTrigger>
                          </div>
                        </div>
                      </div>
                    </div>
                  </li>
                </ul>
              </div>
            </div>
          </div>
        </li>
      </ul>
    </>
  )
}

export default Index